module.exports = __webpack_public_path__ + "static/media/unpaid.856e2848.svg";